var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq-wrap"},[_c('b-container',{staticClass:"faq-content"},[_c('FAQ')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }